export default __webpack_public_path__ + "static/media/empty-search-image.cd8b0f47.png";